import axios from "axios";
import { dbUserAndHub } from "../config/api";
import { encryptUserAndHubPayload } from "./encryption";

export async function fetchActiveStoreCount(token, hubId) {
  const response = await axios.post(
    dbUserAndHub,
    encryptUserAndHubPayload({
      operationType: "read",
      action: "fetchHubs",
      token,
    }),
    { headers: { "Content-Type": "application/json" } },
  );
  const stores = response.data?.adminHubs?.[`HubId:${hubId}`] || [];
  return stores.filter(
    (store) => String(store.ActiveFlag || "active").toLowerCase() !== "deleted",
  ).length;
}
